import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const patientAge = {
    path: '/patientAge',
    component: Layout,
    name: 'patientAge',
    redirect: '/patientAge/index',
    children: [{
      path: '/patientAge/index',
      component: () => import('@/views/patientAge/index'),
      name: 'patientAge.index',
      meta: {
        title: i18n.t(`message.patient_ages`)
      }
    }, ]
  }
  

export default patientAge